import type { IconSvgObject } from './types';

const Heading04Icon: IconSvgObject = [
  ["path", { d: "M16 11V15H20M20 15V19M20 15V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12H13M4 19V5M13 19V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Heading04Icon;
